const Grey = {
    /**The token represent the white color*/
    white: "#ffffff",
    /**The token represents 95% lighter shade of the Grey.white token */
    95: "#FAFAFA",
    /**The token represents 90% lighter shade of the Grey.white token */
    90: "#F5F5F5",
    /**The token represents 85% lighter shade of the Grey.white token */
    85: "#F0F0F0",
    /**The token represents 80% lighter shade of the Grey.white token */
    80: "#EBEBEB",
    /**The token represents 75% lighter shade of the Grey.white token */
    75: "#E6E6E6",
    /**The token represents 70% lighter shade of the Grey.white token */
    70: "#E0E0E0",
    /**The token represents 65% lighter shade of the Grey.white token */
    65: "#DBDBDB",
    /**The token represents 60% lighter shade of the Grey.white token */
    60: "#D6D6D6",
    /**The token represents 55% lighter shade of the Grey.white token */
    55: "#D1D1D1",
    /**The token represents 50% lighter shade of the Grey.white token */
    50: "#CCCCCC",
    /**The token represents 45% lighter shade of the Grey.white token */
    45: "#C7C7C7",
    /**The token represents 40% lighter shade of the Grey.white token */
    40: "#C2C2C2",
    /**The token represents 35% lighter shade of the Grey.white token */
    35: "#BDBDBD",
    /**The token represents 30% lighter shade of the Grey.white token */
    30: "#E0E0E0",
    /**The token represents 25% lighter shade of the Grey.white token */
    25: "#9E9E9E",
    /**The token represents 20% lighter shade of the Grey.white token */
    20: "#757575",
    /**The token represents 15% lighter shade of the Grey.white token */
    15: "#616161",
    /**The token represents 10% lighter shade of the Grey.white token */
    10: "#424242",
    /**The token represents 5% lighter shade of the Grey.white token */
    5: "#212121",
    /**The token represents 0% lighter shade of the Grey.white token */
    0: "#000000",
};

export default Grey;
